import axios from 'axios';
import type { Submission } from './diagnostico';

const BASE_URL = (import.meta.env['VITE_API_URL'] as string | undefined) ?? 'http://localhost:3001';

export const api = axios.create({ baseURL: `${BASE_URL}/api` });

const TOKEN_KEY = 'diagnostico_admin_token';

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t: string) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export async function createDiagnostico(
  data: Omit<Submission, 'id' | 'createdAt'>,
): Promise<Submission> {
  const res = await api.post<Submission>('/diagnosticos', data);
  return res.data;
}

export async function fetchDiagnosticos(): Promise<Submission[]> {
  const res = await api.get<Submission[]>('/diagnosticos');
  return res.data;
}

export async function checkEmailExists(email: string): Promise<boolean> {
  const res = await api.get<{ exists: boolean }>('/diagnosticos/check-email', {
    params: { email },
  });
  return res.data.exists;
}

export async function loginAdmin(email: string, password: string): Promise<void> {
  const res = await api.post<{ token: string }>('/auth/login', { email, password });
  setToken(res.data.token);
}
